import Cookies from "js-cookie";

export interface SessionTokenData {
  accessToken: string;
  fullName: string;
  role?: string;
}

const COOKIE_KEY = "session_token";

export const SessionToken = {
  set: (value: SessionTokenData) => {
    Cookies.set(COOKIE_KEY, JSON.stringify(value), {
      // expires: 7, // cookie berlaku 7 hari (opsional)
      // secure: true, // aktifkan jika pakai https
      sameSite: "strict",
    });
  },

  get: (): SessionTokenData | undefined => {
    const token = Cookies.get(COOKIE_KEY);
    if (!token) return undefined;

    try {
      return JSON.parse(token) as SessionTokenData;
    } catch (error) {
      console.error("Invalid session token:", error);
      return undefined;
    }
  },

  remove: () => {
    Cookies.remove(COOKIE_KEY);
    Cookies.remove("session_token");
  },
};
